import snsAxiosClient from '../common/http/http-sns';
import { get, reduce, toPairs } from 'lodash';

function getSlotsInfo(environmentVariables, user, storeID: string | number) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_GET_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
      storeId: storeID,
    },
  };

  const queryParams = {
    storeId: storeID,
    uuid: get(user, 'UUID'),
  };

  const queryParamsString = reduce(
    toPairs(queryParams),
    (query, [key, value], i) => {
      return `${query}${!!i ? '&' : ''}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    },
    '',
  );

  return snsAxiosClient(options).get(
    `${get(environmentVariables, 'SNS_SLOTS_INFO', 'slots_info')}?${queryParamsString}`,
  );
}

export default getSlotsInfo;
